"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ClickOutside = _interopRequireDefault(require("../ClickOutside"));
var _Container = _interopRequireDefault(require("../Container"));
var _Popup = _interopRequireDefault(require("../Popup"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _Avatar = _interopRequireDefault(require("../Avatar"));
var _Text = _interopRequireDefault(require("../Text"));
var _IconUser = _interopRequireDefault(require("./IconUser"));
var _IconAvatar = _interopRequireDefault(require("./IconAvatar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledButton = _styledComponents.default.button.withConfig({
  displayName: "UserMenu__StyledButton",
  componentId: "sc-1q815bq-0"
})(["display:flex;align-items:center;cursor:pointer;padding:0;transition:all ease 0.3s;background:none;border:none;&:focus{outline:none;}"]);
const UserMenu = ({
  auth,
  user,
  imageResizer,
  iconFill,
  iconFillActive,
  isUserManagement,
  menuItems,
  onOpen,
  onClose,
  onMenuItemClick,
  ...props
}) => {
  const {
    displayName,
    avatar
  } = user;
  const {
    login,
    logout,
    token
  } = auth;
  const [show, setShow] = (0, _react.useState)(false);
  const [buttonHover, setButtonHover] = (0, _react.useState)(false);
  const loggedInItems = [...(menuItems && menuItems.length ? [...menuItems] : []), {
    splitter: true
  }, ...(!isUserManagement ? [{
    text: 'Manage Account',
    icon: 'ls-icon icon-categoryengineering',
    onClick: () => {
      window.open('https://account.localsearch.com.au', '_blank');
    }
  }, {
    splitter: true
  }] : []), {
    text: 'Log Out',
    icon: 'ls-icon icon-generallogin',
    onClick: logout
  }];
  const loggedOutItems = [{
    text: 'Log In',
    onClick: () => {
      login({
        redirectUrl: window.location.pathname
      });
      onMenuItemClick('Login Clicked');
    }
  }, {
    splitter: true
  }, {
    text: 'Create New Account',
    onClick: () => {
      login({
        redirectUrl: window.location.pathname,
        mode: 'register'
      });
      onMenuItemClick('Create New Account');
    }
  }];
  const getAvatarResizeSrc = () => {
    if (!imageResizer) return avatar;
    return imageResizer.resize(avatar, {
      width: 140,
      height: 140
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ClickOutside.default, _extends({
    onClickOutside: () => {
      setShow(false);
      if (show) {
        onClose();
      }
    }
  }, props), /*#__PURE__*/_react.default.createElement(StyledButton, {
    onMouseEnter: () => setButtonHover(true),
    onMouseLeave: () => setButtonHover(false),
    onClick: () => {
      setShow(!show);
      onOpen();
    },
    type: "button"
  }, token() && avatar ? /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    width: "34px",
    height: "34px",
    src: getAvatarResizeSrc()
  }) : /*#__PURE__*/_react.default.createElement(_IconUser.default, {
    fill: buttonHover || show ? iconFillActive : iconFill
  })), /*#__PURE__*/_react.default.createElement(_Popup.default, {
    anchor: "right",
    width: token() ? '240px' : '210px',
    top: "52px",
    show: show
  }, token() && /*#__PURE__*/_react.default.createElement(_Container.default, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 10px 5px 10px"
  }, avatar ? /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    width: "70px",
    height: "70px",
    src: getAvatarResizeSrc()
  }) : /*#__PURE__*/_react.default.createElement(_IconAvatar.default, null), displayName && /*#__PURE__*/_react.default.createElement(_Text.default, {
    fontSize: "18px",
    color: "normal",
    lineHeight: "1.2",
    fontFamily: "circular",
    fontWeight: "bold",
    marginTop: "15px",
    textAlign: "center"
  }, displayName)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    data: token() ? loggedInItems : loggedOutItems
  })));
};
__signature__(UserMenu, "useState{[show, setShow](false)}\nuseState{[buttonHover, setButtonHover](false)}");
UserMenu.propTypes = {
  iconFill: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  iconFillActive: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  auth: _propTypes.default.shape({
    login: _propTypes.default.func,
    logout: _propTypes.default.func,
    token: _propTypes.default.func
  }),
  user: _propTypes.default.shape({
    displayName: _propTypes.default.string,
    avatar: _propTypes.default.string
  }),
  config: _propTypes.default.shape({}),
  isUserManagement: _propTypes.default.bool,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onMenuItemClick: _propTypes.default.func,
  imageResizer: _propTypes.default.shape({
    resize: _propTypes.default.func
  })
};
UserMenu.defaultProps = {
  iconFill: 'white',
  iconFillActive: '#97AEFF',
  auth: {
    login: () => {},
    logout: () => {},
    token: () => {}
  },
  user: {},
  config: null,
  isUserManagement: false,
  menuItems: [],
  onOpen: () => {},
  onClose: () => {},
  onMenuItemClick: () => {},
  imageResizer: null
};
const _default = UserMenu;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledButton, "StyledButton", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/index.js");
  reactHotLoader.register(UserMenu, "UserMenu", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/index.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/index.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();